import { axios, Response } from '../index'

export interface GetUserInformationsByCpfResponse {
  userId: number
  firstName: string
  lastName: string
  email: string
  cpf: string
  gender: string
  birthDay: string
}

const verifyCpf = (cpf: string): Response<GetUserInformationsByCpfResponse> => {
  return axios.get(`/v1/users/${cpf}`)
}

export default verifyCpf
